import { USER_TYPE } from 'app/config/users';

export const checkHomecare = padVisit => {
  const { responsibleType } = padVisit;
  return responsibleType === USER_TYPE.HOMECARE;
};
